/*
 * useInvalidBlockWarning — 自定义 block 的"坏数据"开发期告警
 *
 * 背景：block 组件在数据无效时 return null（流式未收齐时这是对的，不闪占位）。
 * 但组件分不清「流式还没完」和「流式完了但 JSON 真坏」—— 后者会永久静默、
 * 零信号、难排查。
 *
 * 这里用 debounce 兜底：等 code 停止变化（≈ 流式结束）后仍 invalid，才
 * console.warn；流式中途 code 每个 token 都在变，计时器不断重置，不会刷屏。
 */

import { useEffect, useRef } from 'react'

/**
 * @param blockName 代码块语言名（photo-list / echarts …），用于 warn 前缀定位
 * @param code      原始代码块文本
 * @param valid     组件自身判定的"数据有效"结果
 */
export function useInvalidBlockWarning(
  blockName: string,
  code: string,
  valid: boolean
): void {
  // 同一份坏 code 只 warn 一次，避免 re-render 反复打
  const warnedRef = useRef<string>('')

  useEffect(() => {
    if (valid) return
    const timer = setTimeout(() => {
      if (warnedRef.current === code) return
      warnedRef.current = code
      // eslint-disable-next-line no-console
      console.warn(
        `[aiClerk] <${blockName}> 数据无效，已跳过渲染：`,
        code.length > 300 ? `${code.slice(0, 300)}…` : code
      )
    }, 600)
    return () => clearTimeout(timer)
  }, [blockName, code, valid])
}
